import { useState, useEffect, useCallback } from 'react';
// eslint-disable-next-line ferp-subgraph-ui/no-direct-mantine-import
import { TextInput } from '@mantine/core';
// eslint-disable-next-line ferp-subgraph-ui/no-direct-mantine-import
import { useDebouncedValue } from '@mantine/hooks';
import { IconSearch, IconX } from '@tabler/icons-react';

interface SearchInputProps {
  onSearch: (query: string) => void;
  placeholder?: string;
  delay?: number;
  initialValue?: string;
}

export function SearchInput({
  onSearch,
  placeholder = 'Search...',
  delay = 300,
  initialValue = '',
}: SearchInputProps) {
  const [value, setValue] = useState(initialValue);
  const [debounced] = useDebouncedValue(value, delay);

  useEffect(() => {
    onSearch(debounced);
  }, [debounced, onSearch]);

  const handleClear = useCallback(() => {
    setValue('');
  }, []);

  return (
    <TextInput
      placeholder={placeholder}
      leftSection={<IconSearch size={16} />}
      rightSection={
        value ? (
          <IconX
            size={16}
            style={{ cursor: 'pointer' }}
            onClick={handleClear}
          />
        ) : undefined
      }
      value={value}
      onChange={(e) => setValue(e.currentTarget.value)}
    />
  );
}
